import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogPostDateInterface } from 'common/types/entities/BlogPostDateInterface'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createBlogPostDate(
  parentId: string,
  masterBlockId?: MasterBlockId,
): BlogPostDateInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.BlogPostDate, parentId, masterBlockId),
    fontSize: 16,
    color: 'rgba(0, 0, 0, 1)',
    mobileFontSize: 16,
    alignSelf: 'left',
  }
}
